<template>
  <div
    v-click-outside="closeDropdown">
    <button
      :disabled="selectDisabled"
      type="button"
      @click="onOpen($event)"
      ref="ui-select-toggle"
      class="btn ui-select-toggle"
      :class="className"
      href="#">
      {{ selectLabel }} {{ selectedOptions.length > 0 ? ' (selected) ' : '' }}
      <i class="fa fa-caret-down" aria-hidden="true"></i>
    </button>
    <div
      ref="ui-dropdown-modal-holder"
      v-show="showDropdownModal"
      :class="{'active-dropdown': showDropdownModal, 'filtered': selectedOptions.length > 0}"
      class="ui-dropdown-modal-holder">
      <div class="ui-dropdown-modal-header">
        <span class="ui-dropdown-modal-title">
          {{ title }}
        </span>
        <a @click="closeDropdown" class="pull-right ui-close-dropdown-modal">
          <i class="fa fa-times" aria-hidden="true"></i>
        </a>
      </div>
      <div class="ui-dropdown-modal-body">
        <div v-if="searchable" class="ui-dropdown-modal-filter">
          <b-form-input
            @input="onFilter($event)"
            @keydown.down.native="onKeyUpDown('down')"
            @keydown.up.native="onKeyUpDown('up')"
            @keyup.enter.native="onEnterInput()"
            @keyup.esc.native="onEscapeInput($event)"
            v-model="filterValue"
            ref="ui-input-filter"
            autocomplete="off"
            :placeholder="placeholder">
          </b-form-input>
        </div>
        <div class="ui-dropdown-list-container">
          <ul
            class="ui-dropdown-list-holder">
            <li
              v-show="unSelectButton"
              class="ui-unselect--option"
              @click="unSelectAll">
              <div class="ui-dropdown-list-option">
                <span>Unselect All</span>
              </div>
            </li>
            <li
              v-for="(option, index) in optionList"
              @mouseover="onMouseoverOption($event)"
              @click="onCheck(option)"
              :key="option.id">
              <div
                class="ui-dropdown-list-option"
                :option-index="index"
                :class="{'ui-option--active': option.uiArrow}">
                <i class="fa fa-check"
                :class="{
                  'ui-option-not-checked': !option.uiChecked,
                }"
                aria-hidden="true"></i>
                <span :class="{'ui-option-checked': option.uiChecked}">{{ option[label] }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { debounce, find, isEmpty, remove, get, concat, sortBy } from 'lodash';
import ClickOutside from 'vue-click-outside';

export default {
  name: 'ui-multiselect',
  data() {
    return {
      showDropdownModal: false,
      optionList: [],
      selectedOptions: [],
      arrowPosition: null,
      filterValue: '',
    };
  },
  props: {
    initSelect: {
      type: [String, Number, Array],
    },
    label: {
      type: String,
      default: 'name',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    selectLabel: {
      type: String,
      default: 'Select',
    },
    options: {
      type: Array,
      default: [],
      required: true,
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    putOnTopChecked: {
      type: Boolean,
      default: true,
    },
    orderListBy: {
      type: String,
      default: 'name',
    },
    className: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'Select an option',
    },
    placeholder: {
      type: String,
      default: 'Search',
    },
    selectDisabled: {
      type: Boolean,
      default: false,
    },
    unSelectButton: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.bindDataOption(this.options);
  },
  methods: {
    onOpen() {
      const { offsetTop, offsetLeft } = this.$refs['ui-select-toggle'];
      const dropdownModal = this.$refs['ui-dropdown-modal-holder'];
      const fixTop = offsetTop + 40;
      const fixLeft = offsetLeft - 290;

      this.showDropdownModal = !this.showDropdownModal;
      dropdownModal.style.top = `${fixTop}px`;

      if (this.searchable) {
        this.$nextTick(() => this.$refs['ui-input-filter'].$el.focus());
      }

      if (window.innerWidth > 450) {
        dropdownModal.style.left = `${fixLeft}px`;
      }

      if (this.searchable) {
        this.resetArrowPosition();
        this.setHighlight(0);
      }

      this.updateCheckedStatus();
    },
    onFilter: debounce(function onFilter(value) {
      const fixValue = value.trim().toLowerCase();
      if (fixValue !== '') {
        this.optionList = this.options.filter(a => a.name.toLowerCase().indexOf(fixValue) > -1);
      } else {
        this.optionList = this.options;
      }
      this.resetArrowPosition();
      this.setHighlight(0);
    }, 5e2),
    onCheck(option, emit = true) {
      if (isEmpty(option)) return false;
      const isUncheck = !isEmpty(find(this.selectedOptions, { id: option.id }));
      if (isUncheck) remove(this.selectedOptions, { id: option.id });
      if (!isUncheck) {
        if (this.multiple) {
          this.selectedOptions.push(option);
        } else {
          this.selectedOptions = [option];
        }
      }

      if (emit) {
        const emitData = this.multiple ? this.selectedOptions : this.selectedOptions[0] || [];
        this.$emit('select-option', emitData);
      }
      this.updateCheckedStatus();

      if (!this.multiple) this.closeDropdown();

      return true;
    },
    updateCheckedStatus() {
      let notCheckedOptions = [];
      const checkedOptions = [];

      this.optionList.forEach((a) => {
        const isChecked = !isEmpty(find(this.selectedOptions, { id: a.id }));
        a.uiChecked = isChecked;
        if (this.putOnTopChecked) {
          if (isChecked) {
            checkedOptions.push(a);
          } else {
            notCheckedOptions.push(a);
          }
        } else {
          checkedOptions.push(a);
        }
      });

      notCheckedOptions = sortBy(notCheckedOptions, this.orderListBy);
      this.optionList = concat(checkedOptions, notCheckedOptions);
    },
    closeDropdown() {
      if (this.searchable) {
        this.filterValue = '';
      }

      const dropDown = document.querySelector('.active-dropdown .ui-dropdown-list-container');
      if (dropDown) {
        dropDown.scrollTop = '0';
      }

      this.showDropdownModal = false;
    },
    bindDataOption(data) {
      this.optionList.splice(0);
      this.selectedOptions.splice(0);
      this.arrowPosition = null;
      data.forEach((dt) => {
        dt.uiChecked = false;
        dt.uiArrow = false;
        this.optionList.push(dt);
      });
    },
    unSelectAll() {
      this.selectedOptions.splice(0);
      this.updateCheckedStatus();
      this.closeDropdown();
      this.$emit('select-option', this.selectedOptions);
    },
    onKeyUpDown(direction) {
      const pos = direction === 'up' ? -1 : 1;
      const newArrowPosition = this.arrowPosition + pos;
      this.setHighlight(newArrowPosition, direction);
    },
    setHighlight(pos, dir) {
      const options = this.optionList;
      const len = options.length;
      const newOptions = [];

      if (pos < 0 || pos > len - 1) return false;

      this.arrowPosition = pos;

      options.forEach((a) => { a.uiArrow = false; });
      options.forEach((a, i) => {
        if (i === pos) { a.uiArrow = true; }
        newOptions.push(a);
      });

      this.optionList = newOptions;
      const targetOption = document.querySelector('.active-dropdown .ui-option--active');
      const dropDown = document.querySelector('.active-dropdown .ui-dropdown-list-container');

      if (targetOption !== null && dir !== undefined) {
        targetOption.parentElement.scrollIntoView({ block: 'end', inline: 'nearest' });
        if (dir === 'down') {
          dropDown.scrollTop += 35;
        } else {
          dropDown.scrollTop -= 35;
        }
      }

      return true;
    },
    resetArrowPosition() {
      this.arrowPosition = null;
    },
    onEnterInput() {
      const selectedOption = this.optionList[this.arrowPosition];
      this.onCheck(selectedOption);
    },
    onEscapeInput() {
      const value = this.filterValue.trim();
      if (value === '') {
        this.closeDropdown();
      } else {
        this.filterValue = '';
      }
    },
    onMouseoverOption(el) {
      const { target } = el;
      if (target.nodeName !== 'DIV') return false;

      const optionIndex = parseInt(get(target, 'attributes.option-index.value'), 10);
      this.setHighlight(optionIndex);
      return true;
    },
    initCheck(option) {
      this.onCheck(option, false);
    },
  },
  watch: {
    options(a) {
      this.bindDataOption(a);
    },
    initSelect(id) {
      setTimeout(() => {
        if (typeof id === 'object') {
          id.map((i) => {
            const selected = find(this.options, { id: i });
            this.initCheck(selected || []);
            return true;
          });
        } else {
          const selected = find(this.options, { id });
          this.initCheck(selected || []);
        }
      }, 5e2);
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>
<style lang="css">
.ui-select-toggle {
  background: #f0f3f500;
}
.ui-dropdown-modal-holder {
  position: absolute;
  background: #f6f8fa;
  z-index: 5;
  box-shadow: 0 3px 12px rgba(27,31,35,0.15);
  border-radius: 3px;
  border: 1px solid #1b1f2326;
  width: 320px;
}
.ui-dropdown-modal-title {
  font-weight: bold;
  margin-left: 8px;
  font-size: 13px;
}
.ui-dropdown-modal-filter {
  padding: 8px;
  border-bottom: 1px solid #e1e4e8;
}
.ui-dropdown-list-container {
  overflow: auto;
  max-height: 300px;
  background: #fff;
}
.ui-dropdown-list-holder {
  list-style: none;
  padding: 0px;
  margin-bottom: 0px;
}
.ui-dropdown-modal-header {
  padding: 5px;
  border-bottom: 1px solid #e1e4e8;
}
.ui-dropdown-list-option {
  padding: 8px 8px 8px 10px;
  border-bottom: 1px solid #eaecef;
  height: 35px;
  cursor: pointer;
  color: #586069;
}
.ui-option--active {
  background: #0366d6;
  color: #fff !important;
}
.ui-dropdown-list-option > span {
  font-size: 12px;
  margin-left: 3px;
}
.ui-close-dropdown-modal {
  margin-right: 5px;
  cursor: pointer;
  color: #c6cbd1 !important;
}
.ui-close-dropdown-modal:hover {
  color: #444d56 !important;
}
.ui-option-not-checked {
  visibility: hidden;
}
.ui-option-checked {
  font-weight: bold;
}
.ui-unselect--option span {
  margin-left: 20px;
}
.ui-unselect--option > div:hover {
  color: #fff;
  font-weight: bold;
  background: #ff6a6a;
}
</style>



// WEBPACK FOOTER //
// src/components/UiMultiselect.vue